import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { isEmpty, isUndefined } from 'lodash';
import {
  PrefReviewSelector,
  type TTEPreferencesViewLink,
  type TViewLinkSubmitter,
  getViewLink,
  updatePrefReview,
} from 'slices/appsPrefReviewSettings';
import { fetchFields, fieldsSelector } from 'slices/field.slice';
import { useAppDispatch } from 'slices/store';
import {
  Alert,
  Button,
  DefaultContentLayout,
  ScrollableSelect,
} from '@timeedit/ui-components';
import { Col, Row, Typography } from '@timeedit/ui-components/antd';
import intl from '../../../i18n/intl';
import './AllocateSettings.scss';

const AllocateReservationPage = () => {
  const dispatch = useAppDispatch();
  const organizationDetails = useSelector(PrefReviewSelector);
  const language: any = intl.messages;
  const allFields = useSelector(fieldsSelector);

  useEffect(() => {
    dispatch(getViewLink());
    dispatch(fetchFields());
  }, [dispatch]);

  useEffect(() => {
    setForm(organizationDetails);
  }, [organizationDetails]);

  const [form, setForm] = useState<TTEPreferencesViewLink>({
    // TODO: We need validation for this field since the BE expects a boolean one of the typed values
    viewLinkSubmitter: '' as TViewLinkSubmitter,
    viewerEntry: '',
    viewerPath: '',
    viewerPage: '',
    commentField: '',
  });

  function convertToString(name: unknown) {
    return isUndefined(name) ? '' : `${name}`;
  }

  function commentFields(): string[] {
    return convertToString(form.commentField).split(',');
  }

  const _handleSubmit = () => {
    dispatch(updatePrefReview({ ...form }));
  };

  const fieldsOptions = useMemo(() => {
    if (allFields && allFields.length > 0) {
      return allFields
        ?.map((field) => ({
          value: field.id,
          label: `${field.name} (${field.extId} ${field.id})`,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    }
    return [];
  }, [allFields]);

  return (
    <DefaultContentLayout
      title={language.manage_reservation_page}
      actions={
        <Button type="primary" onClick={_handleSubmit}>
          {language.save_changes as string}
        </Button>
      }
    >
      <div className="allocate-settings-container">
        <div className="content-box">
          <Typography.Title className="row-box" level={4}>
            {'Reservation'}
          </Typography.Title>
          <Row className="row-box">
            <Col>
              <ScrollableSelect
                title={'Comment fields: ' + convertToString(form.commentField)}
                value={commentFields()}
                options={fieldsOptions as any}
                onChange={(values) =>
                  setForm({
                    ...form,
                    commentField: values
                      .filter((value) => !isEmpty(value))
                      .join(','),
                  })
                }
                width="100%"
                rowNum={4}
                data-testid="add-field"
              />
            </Col>
          </Row>

          <Alert
            className="help-text"
            description={language.allocateReservationCommentHelp}
            type="info"
            showIcon={false}
          />
        </div>
      </div>
    </DefaultContentLayout>
  );
};

export default AllocateReservationPage;
